import { twMerge } from 'tailwind-merge'

interface LogoProps {
  className?: string
}

export function DachIcon({ className }: LogoProps) {
  return (
    <svg
      className={twMerge('fill-primary', className)}
      height="76.131462mm"
      style={{
        clipRule: 'evenodd',
        fillRule: 'nonzero',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
      }}
      version="1.1"
      viewBox="0 0 583.74606 215.83263"
      width="205.9068mm"
      id="svg6"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs id="defs1" />
      <g
        id="Ebene-1"
        transform="matrix(1.1514701,0,0,1.1514701,-187.72532,-156.24067)"
      >
        <g opacity="1" id="g5">
          <path
            d="m 279.32,149.33 c -2.377,-4.704 -6.166,-8.526 -10.834,-10.92 -5.304,-2.722 -12.245,-2.722 -26.126,-2.722 h -79.329 v 167.795 h 19.484 v 19.646 h 59.845 c 13.881,0 20.822,0 26.126,-2.722 4.668,-2.396 8.457,-6.216 10.834,-10.922 2.7,-5.348 2.7,-12.346 2.7,-26.341 V 175.673 c 0,-13.995 0,-20.992 -2.7,-26.343 z m -53.175,135.256 c 0,4.036 -3.246,7.299 -7.239,7.299 V 166.923 c 4.002,0 7.239,3.273 7.239,7.298 z"
            fillRule="nonzero"
            opacity="1"
            stroke="none"
            id="path1"
          />
          <path
            d="m 163.031,323.128 h 19.484 l -19.484,-19.645 z"
            fillRule="nonzero"
            opacity="1"
            stroke="none"
            id="path2"
          />
          <path
            d="m 408.64,149.33 c -2.377,-4.704 -6.165,-8.526 -10.834,-10.92 -5.304,-2.722 -12.245,-2.722 -26.127,-2.722 h -39.661 c -13.881,0 -20.822,0 -26.127,2.722 -4.668,2.394 -8.457,6.216 -10.833,10.92 -2.7,5.351 -2.7,12.348 -2.7,26.343 v 147.456 h 55.875 v -70.81 h 7.241 v 70.81 h 55.875 V 175.673 c 0,-13.995 0,-20.992 -2.701,-26.343 z m -53.175,67.582 h -7.241 v -46.338 c 0,-2.019 1.618,-3.651 3.621,-3.651 2.002,0 3.62,1.632 3.62,3.651 z"
            fillRule="nonzero"
            opacity="1"
            stroke="none"
            id="path3"
          />
          <path
            d="M 540.658,252.319 V 135.688 h -79.329 c -13.881,0 -20.821,0 -26.126,2.722 -4.668,2.394 -8.457,6.216 -10.833,10.92 -2.701,5.351 -2.701,12.348 -2.701,26.343 v 147.456 h 79.321 c 13.881,0 20.823,0 26.129,-2.722 4.666,-2.396 8.456,-6.216 10.833,-10.922 2.706,-5.348 2.706,-12.346 2.706,-26.341 v -23.526 h -55.875 v 24.968 c 0,4.036 -3.243,7.299 -7.239,7.299 V 174.23 c 0,-4.034 3.246,-7.298 7.239,-7.298 v 85.387 z"
            fillRule="nonzero"
            opacity="1"
            stroke="none"
            id="path4"
          />
          <path
            d="m 650.502,135.688 19.486,19.645 h -19.486 v -19.645 h -36.39 v 70.808 h -7.248 v -70.808 h -55.866 v 187.441 h 55.866 v -70.81 h 7.248 v 70.81 h 55.876 V 135.688 Z"
            fillRule="nonzero"
            opacity="1"
            stroke="none"
            id="path5"
          />
        </g>
      </g>
    </svg>
  )
}
